import { render, staticRenderFns } from "./topicMain.vue?vue&type=template&id=af4764c8&scoped=true&"
import script from "./topicMain.vue?vue&type=script&lang=js&"
export * from "./topicMain.vue?vue&type=script&lang=js&"
import style0 from "./topicMain.vue?vue&type=style&index=0&id=af4764c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4764c8",
  null
  
)

export default component.exports